module.exports = __webpack_public_path__ + "static/media/22ESCWA21.a48862a1.jpg";